module.exports = __webpack_public_path__ + "img/aqua_aquascapeart.9270ada.png";